import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
require('./bootstrap');
require('jquery-countdown');
require('slick-carousel');

(function($) {
  $(document).ready(function() {   
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(".bt-tooltip").tooltip();

    if($('#start-course-form').length){
        $('#page-body').on('click','.scrolling-btn',function(e){
            var form = $("#start-course-form")[0];

            smoothScroll( form, { behavior: "auto", block: "nearest" }).then( () => {

                // if(!$("#start-course-form").isInViewport()) {
                    // FallBack for old browsers
                    $('html, body').animate({
                        scrollTop: $("#start-course-form").offset().top
                    }, 200);
                // }
            })
            return false;
        });
    }


    if($('#desktop-slider').length && $('#mobile-slider').length){
        // $('#desktop-slider').slick();
        var desktopSlick = $('#desktop-slider').slick({
          // lazyLoad: 'ondemand',
          dots: true,
          arrows: true,
          infinite: true,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 9000,
          slidesToShow: 1,
          useTransform: false,
          // adaptiveHeight: true,
          nextArrow: '#sample-next',
          prevArrow: '#sample-prev',
          // fade: true,
          // cssEase: 'linear'
        });


        var mobileSlick = $('#mobile-slider').slick({
          // lazyLoad: 'ondemand',
          dots: false,
          arrows: false,
          infinite: true,
          speed: 500,
          autoplay: false,
          autoplaySpeed: 9000,
          slidesToShow: 1,
          useTransform: false,
          // adaptiveHeight: true,
          // fade: true,
          // cssEase: 'linear'
        });


        // $('#mobile-slider').on('swipe', function(event, slick, direction){
        //   var currentMobileSlide = $('#mobile-slider').slick('slickCurrentSlide');
        //   $('#desktop-slider').slick('slickGoTo', parseInt(currentMobileSlide));

        // });
        $('#desktop-slider').on('afterChange', function(event, slick, direction){
          var currentDesktopSlide = $('#desktop-slider').slick('slickCurrentSlide');
          $('#mobile-slider').slick('slickGoTo', parseInt(currentDesktopSlide));

        });

        // $('#desktop-slider').on('click', '.slick-dots button',function(event, slick, direction){
        //   var currentDesktopSlide = $('#desktop-slider').slick('slickCurrentSlide');
        //   $('#mobile-slider').slick('slickGoTo', parseInt(currentDesktopSlide));

        // });

        // $(desktopSlick).on('click', function (e){ 
        //     var slideClicked = $(e.currentTarget).attr("data-slick-index"); 
        //     console.log(slideClicked); 
        // });

    }




    if($('#slider-on-reviews-homepage').length > 0){

      var winWidth = $(window).width();
      var containerWidth = $('#customer-reviews').width();
      var rightSide = parseInt((winWidth - containerWidth)/2);

      var reWcontainerWidth = $('#no-wrap').closest('.container').width();
      var reWholderWidth = $('#no-wrap').closest('.reviews-holder-column').width();
      var reWrightSide = parseInt((winWidth - containerWidth)/2);
      var reWflexedWidth = parseInt(reWholderWidth+rightSide+165);


      if($(window).width() > 991)
        $('#no-wrap').css({'width': reWflexedWidth+'px'})


        setTimeout(function () {
          var topReviews = $('#slider-on-reviews-homepage').slick({
                // lazyLoad: 'ondemand',
                dots: false,
                arrows: true,
                infinite: true,
                speed: 500,
                autoplay: true,
                autoplaySpeed: 9000,
                slidesToShow: 2,
                adaptiveHeight: true,
                nextArrow: '#review-next',
                prevArrow: '#review-prev',
                responsive: [
                  {
                    breakpoint: 991,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
              });

            if($(window).width() > 991){

                $('#drivers-ed-coach-reviews').find('#review-next').css({'left': parseInt((reWflexedWidth/2)-52)+'px'});
                $('#drivers-ed-coach-reviews').find('#review-prev').css({'left': parseInt((reWflexedWidth/2)-92)+'px'});
            }
            
            $('#slider-on-reviews-homepage').on('afterChange', function(event, slick){
              var currentDesktopSlide = $('#slider-on-reviews-homepage').slick('slickCurrentSlide');
              $('#drivers-ed-coach-reviews').find('.counter span.active-review').text(parseInt(currentDesktopSlide+1));

            });




        }, 400);

    }


    if($('mark.timer').length > 0){
      $.each($('mark.timer'),function(i,k){

          var currentCounter = $(k).find('.total-clock-datetime');

          var startDate = $(currentCounter).attr('datetime');

          if($(currentCounter).data('countdown')){
               
                var secondsPass = new Date().getTime() + (startDate*1000);

                $(currentCounter).find('.total-clock-time').countdown(secondsPass, {elapse: false})
                .on('finish.countdown', function(event) {
                  var $this = $(this);
                  if (event.elapsed) {
                    // Test was over , So call PopUp
                    $('#examFinished').modal('show');

                    $('#examFinished').on('hidden.bs.modal', function (e) {
                       var urlRedirect = $('#examFinished').find('#reviewLinkForce');
                       if($(urlRedirect).length > 0)
                        window.location.href = $(urlRedirect).attr('href');
                    })

                  } else {
                    var trimmed = event.strftime('%H:%M:%S').substring(1);
                    $this.html(trimmed);
                  }
                  
                })
                .on('update.countdown', function(event) {
                  var $this = $(this);
                  if (event.elapsed) {
                    // Test was over , So call PopUp
                    var trimmed = event.strftime('%H:%M:%S').substring(1);
                    $this.html(trimmed);
                  } else {
                    var trimmed = event.strftime('%H:%M:%S').substring(1);
                    $this.html(trimmed);
                  }
                });

          }else{

              var date = new Date(null);
                  date.setSeconds(startDate); 
                  var timeString = date.toISOString().substr(11, 8);
                  $(currentCounter).find('.total-clock-time').html(timeString);
          }
      });

    }


    setTimeout(function() {
      $.hide_notification();
    }, 7000);
    $.append_notification = function(status,text_content){
    // function append_notification(status,text_content){
       
        var randomString = 'notification_'+Math.random().toString(36).substring(7);
        var notification_html = '<div class="mb-2 toast align-items-center '+status+' '+randomString+'" role="alert" aria-live="assertive" aria-atomic="true">'+
                                    '<div class="d-flex">'+
                                    '<div class="toast-body">'+text_content+'</div>'+
                                    '<button type="button" class="btn-close me-2 m-auto btn-close-white" data-bs-dismiss="toast" aria-label="Close"></button>'+
                                    '</div>'+
                                '</div>';

        $('#notification_content').prepend(notification_html).promise().done(function(){ 
            var myAlert = $('#notification_content').find('.'+randomString);
            $(myAlert).toast('show');

            myAlert[0].addEventListener('hidden.bs.toast', function () {
              // $(myAlert).remove();
            })
        }); 

    }

    $.hide_notification = function(){
        var myAlert = $('#notification_content').find('.toast');
        $(myAlert).toast('hide');
    }

    function smoothScroll( elem, options ) {
          return new Promise( (resolve) => {
              if( !( elem instanceof Element ) ) {
                  throw new TypeError( 'Argument 1 must be an Element' );
              }
              var same = 0;
              var lastPos = null;
              const scrollOptions = options;

              elem.scrollIntoView( scrollOptions );
              requestAnimationFrame( check );
              function check() {
                  var newPos = elem.getBoundingClientRect().top;
                  if( newPos === lastPos ){
                      if(!$("#start-course-form").isInViewport()){
                          same = 0;
                          lastPos = null;
                          elem.scrollIntoView( scrollOptions );
                      }else{
                          return resolve();
                      }
                  }
                  else {
                      same = 0;
                      lastPos = newPos;
                  }
                  requestAnimationFrame(check);
              }

          });
    }

    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop() + ($(window).height() / 2);
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
  };


    $.fn.validate = function(rules,callback){
        var FUNCTIONS = {
            bigger : function(object,rule){
                if ($(object).val() > rule)
                  return true;
                return false;
            },
            longer : function(object,rule){
                var value = $(object).val();                
                if (value.length > rule) 
                    return true;
                return false;
            },
            shorter : function(object,rule){
                  var value = $(object).val();
                  if (value.length < rule) 
                      return true;
                  return false;
            },
            eq : function(object,rule){

                  var value = $(object).val();
                  if (value.length < rule) 
                      return true;
                  return false;
            },
            validEmail : function(object,rule){
                  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                  return re.test($(object).val());
            },
            lesser : function(object,rule){
              if ($(object).val() < rule) return true;
              return false;
            },
            equal : function(object,rule){
              if($(object).val() == rule) return true;
              return false;
            },
            isChecked : function(object,rule){
              if($(object).prop('checked')){
                $(object).val('1');
              }
              else{
                $(object).val('');
              }
            },
            hasValue : function(object,rule){
              var value = $(object).val();

              if(!value || value=='' || value==' ' || value == null || typeof value == 'undefined') 
                return false;
              else
                return true;
            },
            isInt : function(object,rule){
              var value = $(object).val();
              if (rule=='1'){
                return parseInt(value) % 1 == 0;
              }
              else
                return !(parseInt(value) % 1 == 0);
            }
        };

        var data_rules = $(this).attr('data-rules') || '',
            rules = rules || {};

        var rules_split = data_rules.split(';');

            $.each(rules_split,function(i,rule){
                var matches = rule.split(':');
                if (matches[0] && matches[1])
                  rules[matches[0]] = matches[1];
            });
        
        if (!$.isEmptyObject(rules)){

            var rArray=[true],
                that = this;

            $.each(rules,function(aRule,aValue){
                var callee = FUNCTIONS[aRule];
                if (callee)
                    rArray.push(callee(that,aValue));
            });

            return ($.inArray(false, rArray)==-1);
        }
        else{
          return true;
        }

    }


    $.fn.executeValidation = function(){

      var validArray = [],
          message = '',
          o = {},
          valid = true;



      $(this).each(function(i,k){
          
          var validation = $(k).validate(),
              data_validation_message = $(k).attr('data-validation-message');

          if (!validation){ 
              $(k).addClass('not-valid');
              message += '<p>'+data_validation_message+'</p>';
          }
          else{
              $(k).removeClass('not-valid');
          }

          var name = $(k).attr('name'),
              val = $(k).val();

           if (o[name]) {
               if (!o[name].push) {
                   o[name] = [o[name]];
               }
               o[name].push(val || '');
           } else {
               o[name] = val || '';
           }              

          validArray.push({
              'dom' : k,
              'valid' : validation,
              'message' : data_validation_message
          });

      });

      $.each(validArray,function(i,k){
          if (!k.valid){
              valid = false;
              return false;
          }
      });
      return {'status':valid,'message':message,'validArray':validArray,'o':o};
    }

  });
})(jQuery);